/* Dữ liệu tĩnh dùng chung cho trang Reflections (4F). */
import type { AnyIconName } from "@/components/icon"

export type ReflectionForm = {
  id: string
  reflection_date: string
  starts_at: string
  ends_at: string
  learning_context: "class_session" | "self_study" | string
  facts: string
  feelings: string
  findings: string
  future: string
}
export type FieldKey = "facts" | "feelings" | "findings" | "future"

export const emptyReflection = (): ReflectionForm => ({
  id: "",
  reflection_date: new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Ho_Chi_Minh" }).format(new Date()),
  starts_at: "",
  ends_at: "",
  learning_context: "class_session",
  facts: "",
  feelings: "",
  findings: "",
  future: "",
})

export const FIELDS: { key: FieldKey; title: string; prompt: string; placeholder: string; example: string }[] = [
  { key: "facts", title: "Facts", prompt: "Điều gì đã xảy ra?", placeholder: "Viết điều con nhìn thấy hoặc nghe thấy…", example: "Em làm quiz lúc 19:00 và sai câu 2." },
  { key: "feelings", title: "Feelings", prompt: "Con cảm thấy gì?", placeholder: "Gọi tên cảm xúc của con…", example: "Em hơi buồn và lo vì chưa hiểu câu hỏi." },
  { key: "findings", title: "Findings", prompt: "Con hiểu ra điều gì?", placeholder: "Viết điều con vừa nhận ra…", example: "Em nhận ra mình thường bỏ sót từ “không”." },
  { key: "future", title: "Future", prompt: "Con sẽ thử gì tiếp?", placeholder: "Viết một bước nhỏ…", example: "Quiz sau, em sẽ gạch chân từ “không”." },
]

export const INTRO: { icon: AnyIconName; title: string; copy: string; example: string }[] = [
  { icon: "zap", title: "Không mắc kẹt khi làm sai", copy: "4F giúp con nhìn rõ chuyện đã xảy ra, thay vì vội trách mình.", example: "Sai 2 câu không có nghĩa là con kém." },
  { icon: "lightbulb", title: "Biến trải nghiệm thành bài học", copy: "Con nhận ra cảm xúc và điều mình vừa hiểu được.", example: "“À, mình đã đọc sót một từ quan trọng.”" },
  { icon: "target", title: "Biết bước nhỏ tiếp theo", copy: "Con chọn một việc cụ thể để lần sau làm tốt hơn.", example: "“Lần sau mình sẽ gạch chân từ khóa.”" },
]

export const LEVEL_LABELS = ["Chưa thể hiện", "Bắt đầu", "Đang phát triển", "Đạt", "Tốt"]

export const STATUS_LABEL: Record<string, string> = {
  draft: "Bản nháp",
  submitted: "Đang xếp hàng chấm",
  evaluating: "Đang đánh giá",
  evaluated: "Đã đánh giá",
  failed: "Cần chấm lại",
}

export const isPending = (status?: string) => status === "submitted" || status === "evaluating"
export const score100 = (v: unknown) => Math.round(Number(v || 0) * 100)
export const contextLabel = (c?: string) => (c === "self_study" ? "Tự học" : "Buổi học")
